import React from 'react';

import { SuggestionDataItem, MentionProps } from 'react-mentions';

import { useMentionableAssetQuery } from '@interfaces/graphql-typings';

import styles from '@buyside/components/container/Mentionable/mentionableAssetStyles.scss';

const useMentionableAsset = (): [
  MentionProps['data'],
  MentionProps['markup'],
  MentionProps['renderSuggestion'],
  MentionProps['displayTransform']
] => {
  const { refetch } = useMentionableAssetQuery({ variables: { query: '' } });

  const markup = '$[__display__](__id__)';

  const renderSuggestion = (
    _entry: SuggestionDataItem,
    _search: string,
    highlightedDisplay: React.ReactNode,
    index: number,
    focused: boolean
  ): React.ReactElement => (
    <div className={`user ${focused ? 'focused' : ''}`}>
      {highlightedDisplay}{' '}
      {index === 9 && <span className={styles.moreResults}>More results, keep typing...</span>}
    </div>
  );

  const displayTransform = (_id: string, display: string): string =>
    `${display.substr(0, display.lastIndexOf(':'))}`;

  const getMentionableAssets = (query: string): Promise<SuggestionDataItem[]> =>
    refetch({ query }).then(response => {
      return (
        response?.data?.assetsByBloombergSymbol?.map(asset => ({
          id: asset.mentionId,
          display: asset.mentionDisplay
        })) || []
      );
    });

  const mentionableAssets = (query = '', callback: (data: SuggestionDataItem[]) => void): void => {
    getMentionableAssets(query).then(callback);
  };

  return [mentionableAssets, markup, renderSuggestion, displayTransform];
};

export default useMentionableAsset;
